import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, mergeProps as _mergeProps, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "gt-auth-form" }
const _hoisted_2 = { class: "gt-auth-form__title gt-space_mb gt-space_mb--7" }
const _hoisted_3 = { class: "ds-caption ds-caption--size_lg ds-caption--bold ds-caption--appearance_center" }
const _hoisted_4 = { class: "gt-auth-form__wrapper" }
const _hoisted_5 = { class: "error-label error-label----styled" }
const _hoisted_6 = { class: "global-error" }
const _hoisted_7 = { class: "g-row g-row--appearance_spaced g-row--space_sm g-row--space_xl-xl g-row--align_center g-row--justify_center" }
const _hoisted_8 = { class: "g-cell g-cols g-cols--12" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "gt-button__title" }
const _hoisted_11 = { class: "g-cell g-cols g-cols--narrow" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loader = _resolveComponent("loader")!
  const _component_VeeError = _resolveComponent("VeeError")!
  const _component_d_control_input = _resolveComponent("d-control-input")!
  const _component_VeeForm = _resolveComponent("VeeForm")!
  const _directive_mask = _resolveDirective("mask")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($setup.load)
      ? (_openBlock(), _createBlock(_component_loader, { key: 0 }))
      : _createCommentVNode("", true),
    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "gt-auth-form__logo-wrapper gt-space_mb gt-space_mb--7" }, [
      _createElementVNode("img", {
        class: "gt-auth-form__logo",
        src: "/static/app/gt-auth-logo.svg",
        alt: "tt-logo-image"
      })
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, _toDisplayString($setup.$t('Recover password')), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_VeeForm, {
        onSubmit: $setup.request,
        ref: "formRef"
      }, {
        default: _withCtx(({ errors, validate, values, setErrors, setFieldError, isSubmitting }) => [
          _createVNode(_component_VeeError, { name: "nonFieldErrors" }, {
            default: _withCtx(({ message }) => [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, _toDisplayString(message), 1)
              ])
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.fields, (field) => {
              return (_openBlock(), _createElementBlock("div", {
                key: field.name,
                class: "g-cell g-cols g-cols--12"
              }, [
                _withDirectives((_openBlock(), _createBlock(_component_d_control_input, _mergeProps({ ref_for: true }, field, {
                  ref_for: true,
                  ref: field.name,
                  name: field.name,
                  "input-label": field.label,
                  modelValue: $setup.formData[field.name],
                  "onUpdate:modelValue": ($event: any) => (($setup.formData[field.name]) = $event),
                  key: $setup.keyForReloading
                }), null, 16, ["name", "input-label", "modelValue", "onUpdate:modelValue"])), [
                  [_directive_mask, field?.mask]
                ])
              ]))
            }), 128)),
            _createElementVNode("div", _hoisted_8, [
              _createVNode($setup["TokenConfirmationCheck"], {
                token: $setup.formData.token,
                action: $event => $setup.request($event, $setup.formRef),
                "request-api-url": $setup.passwordResetRequestResource,
                "additional-data": { way: $setup.way, newPassword1: $setup.formData.newPassword1, newPassword2: $setup.formData.newPassword2 },
                onError: ($event: any) => (setFieldError("nonFieldErrors", $event))
              }, {
                default: _withCtx(({ is_confirmed, sendCode, openModal }) => [
                  _createElementVNode("button", {
                    class: _normalizeClass(["gt-button", {'disabled' : isSubmitting || _ctx.isLoad}]),
                    type: "submit",
                    onClick: _withModifiers(($event: any) => ($setup.validateForm(validate, sendCode, $setup.formRef)), ["prevent"])
                  }, [
                    _createElementVNode("span", _hoisted_10, _toDisplayString($setup.$t('Recover')), 1)
                  ], 10, _hoisted_9)
                ]),
                _: 2
              }, 1032, ["token", "action", "request-api-url", "additional-data", "onError"])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("p", null, [
                _createElementVNode("span", {
                  class: "ds-caption ds-caption--color_accent ds-caption--size_xs pointer",
                  onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => ($setup.toAuthForm()), ["prevent"]))
                }, _toDisplayString($setup.$t('Back to login')), 1)
              ])
            ])
          ])
        ]),
        _: 1
      }, 512)
    ])
  ]))
}